(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.currentScript?.closest('cart-drawer-component') || document.querySelector('cart-drawer-component');
    if (!drawer) return;
    const dialog = drawer.querySelector('dialog[ref="dialog"]');
    if (!dialog) return;

    const onOpen = () => {
      const raw = drawer.dataset.customerMetafield;
      if (raw && raw !== 'null' && raw !== 'undefined') {
        try {
          const value = JSON.parse(raw);
          console.log('Customer metafield (custom.contractid):', value);
        } catch (e) {
          console.warn('Failed to parse customer metafield');
        }
      } else {
        console.log('Customer metafield not available or customer not logged in.');
      }
    };

    // Observe when the dialog opens (open attribute toggles)
    const mo = new MutationObserver(() => {
      if (dialog.open) onOpen();
    });
    mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    const isCheckoutEl = (el) => !!el && (el.matches('a[href^="/checkout"], button[name="checkout"], button[data-role="checkout"]'));
    const proceedToCheckout = (el) => {
      console.log('[checkout] proceeding to checkout (drawer -> direct)');
      if (el && el.tagName === 'A' && el.href) {
        window.location.href = el.href;
      } else {
        window.location.href = '/checkout';
      }
    };

    drawer.addEventListener('click', (e) => {
      const el = e.target.closest('a[href^="/checkout"], button[name="checkout"], button[data-role="checkout"]');
      if (!isCheckoutEl(el)) return;
      e.preventDefault();
      window.location.href = '/cart';
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
